export const LOAD_PRODUCTS = "LOAD_PRODUCTS";
export const LOAD_PRODUCTS_SUCCESS = "LOAD_PRODUCTS_SUCCESS";
export const LOAD_PRODUCTS_FAIL = "LOAD_PRODUCTS_FAIL";
export const PRODUCT_LOW_TO_HIGH = "PRODUCT_LOW_TO_HIGH";
export const PRODUCT_HIGH_TO_LOW = "PRODUCT_HIGH_TO_LOW";
export const PRICE_ABOVE_500 = "PRICE_ABOVE_500";
export const PRICE_BELOW_500 = "PRICE_BELOW_500";
export const PRICE_BETWEEN_500_AND_999 = "PRICE_BETWEEN_500_AND_999";
export const PRICE_BETWEEN_1000_AND_4999 = "PRICE_BETWEEN_1000_AND_4999";
export const PRICE_5000_PLUS = "PRICE_5000_PLUS";

export const CLEAR_ALL_FILTERS = "CLEAR_ALL_FILTERS";
export const SET_CATEGORY_PRODUCTS_NULL = "SET_CATEGORY_PRODUCTS_NULL";

export const LOAD_EACH_PRODUCT = "LOAD_EACH_PRODUCT";
export const LOAD_EACH_PRODUCT_SUCCESS = "LOAD_EACH_PRODUCT_SUCCESS";
export const LOAD_EACH_PRODUCT_FAIL = "LOAD_EACH_PRODUCT_FAIL";

export const SEARCH_PRODUCTS = "SEARCH_PRODUCTS";
export const SEARCH_PRODUCTS_SUCCESS = "SEARCH_PRODUCTS_SUCCESS";
export const SEARCH_PRODUCTS_FAIL = "SEARCH_PRODUCTS_FAIL";